export class Endpoints {
    static host = process.env.REACT_APP_BACKEND_URL
    // bookings
    static transcriptions = this.host + 'transcriptions_poc_000113_1_0_0/transcription/';
    static customWords = this.host + 'transcriptions_poc_000113_1_0_0/custom-word/';
    static paragraphs = this.host + 'transcriptions_poc_000113_1_0_0/paragraph/';
    static headings = this.host + 'transcriptions_poc_000113_1_0_0/heading/';
    static prompts = this.host + 'transcriptions_poc_000113_1_0_0/prompt/';
    static tags = this.host + 'transcriptions_poc_000113_1_0_0/tag/';
    static transcriptionTags = this.host + 'transcriptions_poc_000113_1_0_0/transcription-tag/';
    static paragraphWords = this.host + 'transcriptions_poc_000113_1_0_0/paragraph-word/';
    static transcriptionHighlights = this.host + 'transcriptions_poc_000113_1_0_0/transcription-highlight/';
    static transcriptions2 = this.host + 'wav_transcript_000073_1_0_0/';
}
